<template>
	<article class='knd-article' :class="{ 'show-body': showBody }">
		<div class='knd-article-header'  v-on:click="toggle">			
			<div class='knd-flex'>
				<div class='knd-header--left'>
<!-- 					<div class='knd-article-status' :class="'status-'+ article.oordeel.id">
						<span>{{article.oordeel.label}}</span>
					</div>
 -->						
			<h2>{{article.titel}}</h2>
			</div>
				<div class='knd-header--right'>
					<div class='knd-article-icon knd-show-icon'>
						<ArrowIcon />
					</div>
				</div>
			</div>
			<!-- <div class='last-update'>{{formatDate(article.datum)}}</div> -->
		</div>

		<transition name="slide">
			<div class='knd-article-body' v-if='showBody'>
				<swiper
					:slidesPerView="1.2"
					:spaceBetween="20"
					:breakpoints='{
						"640": {
							"spaceBetween": 20,
							"slidesPerView": 1.2
						}
					}'
					:centeredSlides="true" 
					:grabCursor="true"
					:pagination='{
						"dynamicBullets": true
					}'
					:style="{'--swiper-navigation-color': '#07034A','--swiper-pagination-color': '#07034A'}" 
					:lazy="true" 
					class='knd-swiper'
				>
				<swiper-slide 
					class='knd-article__slide'
					v-for="(slide, index) in article.slides" 
					:class="{'knd-slide__even': index % 2 === 0}"
					:key="index +'-article'"
					>
					<component 
						v-for="(paragraaf, i) in slide" 
						:is="paragraaf.type" 
						:data="paragraaf" 
						:key="index + '-paragraaf-' + i">
					</component>
				</swiper-slide>

				<swiper-slide 
					v-if="article.bronnenlijst.length > 0 || article.byline[0].name.length > 0">
					<div class='article-bronnenlijst'>
						<paragraafBronnenlijst 
							v-if="article.bronnenlijst.length > 0" 
							:data="article.bronnenlijst" />
						<paragraafByline 
							:byline="article.byline" />
					</div>
				</swiper-slide>
			</swiper>


			</div>
		</transition>

		<div class='knd-article--footer'>
			<div class='knd-article--footer-inner'>
				<div class='knd-article-tags'>
					<div class="knd-article-tag" 
						v-for="(thema, index) in article.themas" 
						:key="'thema-' + index"
						:style="{background: thema.color}"
					>
						<span v-if="thema.label">
							{{thema.label}}
						</span>
					</div>
				</div>

				<div class='knd-social'>
					<CopyLink :id="article.id" />	
				</div>
			</div>
		</div>
	</article>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import SwiperCore, { Lazy, Pagination } from 'swiper';

	SwiperCore.use([Pagination, Lazy]);

	import "swiper/swiper-bundle.min.css";
	import 'swiper/components/lazy/lazy.min.css'

	import ConclusieSlide from './conclusie-slide';
	import paragraafTekst from '@/js/components/paragrafen/paragraaf-tekst';
	import paragraafImg from '@/js/components/paragrafen/paragraaf-img';
	import paragraafVimeo from '@/js/components/paragrafen/paragraaf-vimeo';
	import paragraafTwitter from '@/js/components/paragrafen/paragraaf-twitter';
	import paragraafByline from '@/js/components/paragrafen/paragraaf-byline';
	import paragraafBronnenlijst from '@/js/components/paragrafen/paragraaf-bronnenlijst';

	import CopyLink from './copy-link';

	import ArrowIcon from '@/assets/icons/pijl.svg?inline';

	const vueObject = {
		props: ['article', 'open'],
		components: {
			Swiper,
			SwiperSlide,
			ArrowIcon,
			ConclusieSlide,
			paragraafTekst,
			paragraafImg,
			paragraafVimeo,
			paragraafTwitter,
			paragraafByline,
			paragraafBronnenlijst,
			CopyLink		
		},		
		data() {
			let swiperOptions = {
				centeredSlides: true,
				grabCursor: true,
				preloadImages: false,
				lazy: {
					loadPrevNext: true
				},
				breakpoints: {
					640: {
						slidesPerView: 1.2,
						spaceBetween: 20
					},
					320: {
						slidesPerView: 1.2,
						spaceBetween: 20
					}
				}		
			}

			if(this.article.slides && this.article.slides.length > 1) {
				swiperOptions.navigation = {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}

				swiperOptions.pagination = {
					el: '.swiper-pagination',
					clickable: true,
					dynamicBullets: true
				}
			}

			return {
				showBody: false,
				swiperOptions
			}
		},
		computed: {
			// swiper() {
			// 	if(!this.$refs.mySwiper) return
			// 	return this.$refs.mySwiper.$swiper
			// }
		},
		mounted() {
			if(this.open) {
				this.showBody = true;
			}

			console.log(this.article.byline);
		},
		watch: { 
			open: function(newVal, oldVal) { // watch it
				if(newVal) {
					this.showBody = true;
				}
			}
		},
		methods: {
			onSwiper(swiper) {
				this.swiper = swiper;
			},

			toggle() {
				this.toggleVisible();

				let id = this.showBody ? this.article.id : undefined;
				this.updateLink(id)
			},

			updateLink(id) {
				if(id) {
					this.$router.push({  name: 'Articles', query: Object.assign({}, this.$route.query, { article: id }) });
				} else {
					this.resetLink();
				}
			},

			resetLink() {
				this.$router.push({  name: 'Articles', query: Object.assign({}, this.$route.query, { article: undefined }) });
			},

			toggleVisible() {
				this.showBody = !this.showBody;
			}

		}
	}

	export default vueObject;
</script>